module.exports = __webpack_public_path__ + "46a028e85763f2b2ff5472d2f4d7aaf1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/tesla_2023_chart.png
// module id = 1748
// module chunks = 0